<div class="slide-entry">
    <div *ngFor="let review of reviews"
        [ngClass]="mobile?'slide-content mobile-slide-content has-text-dark':'slide-content desktop-slide-content has-text-dark'">
        <div class="review-info">
            <div class="review-name">{{truncateName(review)}}</div>
            <div class="review-date">{{review.pretty_time}}</div>
        </div>
        <div class="review-text">
            <span class="has-text-grey">{{formText(review.review)}}</span>
        </div>
        <app-custom-star-rating [rating]="review.overall_rating"></app-custom-star-rating>
    </div>
</div>